import BusinessIcon from '@material-ui/icons/Business';
export const OrganisatieIcon = BusinessIcon